<script lang="ts">
  import Loading from '$lib/components/Loading.svelte';
  import SkillCheckBox from '$lib/components/student/SkillCheckBox.svelte';
  import type { PageProps } from './$types';
  import BottomNextBtn from '$lib/components/student/BottomNextBtn.svelte';
  import { goto } from '$app/navigation';
  import { getContext } from 'svelte';
  import type { SkillLogContext } from '$lib/componentTypes';
  import { SvelteSet } from 'svelte/reactivity';
  import BackBtn from '$lib/components/common/BackBtn.svelte';
  import { page } from '$app/state';
  // ./log will be arranged as follows:
  // ./log/ will have the choose skills screen
  // ./log/[skill_id] will have the screen to evaluate proficiency level
  // ./log/confirmation will be the confirmation screen to see the updated results
  //
  // The Next buttons will be <a> tags that navigate between the links above. we will need to use context probably in
  // the layout to keep track of which skills are checked.

  let { data, params }: PageProps = $props();

  let filteredCategoryId: number | null = $derived.by(() => {
    const categoryIdStr = page.url.searchParams.get('categoryId');
    if (categoryIdStr === null) return null;
    const catId = parseInt(categoryIdStr);
    if (isNaN(catId)) return null;
    return catId;
  });

  let checkedSkills = new SvelteSet<number>();

  let { setOrderedSelectedSkills } = getContext<SkillLogContext>('skillLog');
</script>

<BackBtn />

<form
  onsubmit={e => {
    e.preventDefault();
    // pull the order of the checked skill ids from the order they are presented to the user. the set is unordered so
    // there's no guarantee they will be in the order presented.
    const checkedElements = e.currentTarget.querySelectorAll('[data-skill-id][aria-checked="true"]');
    const skillIds = Array.from(checkedElements).map(x => parseInt((x as HTMLButtonElement).dataset.skillId!));
    setOrderedSelectedSkills(skillIds);
    goto(`/classes/${params.id}/log/${skillIds[0]}`);
  }}
>
  <fieldset>
    <legend>
      <h2>Choose Skills</h2>
    </legend>
    <p>
      Select one or more skills to log. You will be able to self-evaluate your proficiency level individually for each
      skill you log.
    </p>

    {#await data.classPromise}
      <Loading />
    {:then leaderboard}
      {@const filteredCategories =
        filteredCategoryId === null
          ? leaderboard.class.course.skillCategories
          : leaderboard.class.course.skillCategories.filter(x => x.id === filteredCategoryId)}
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 justify-content-center">
        {#each filteredCategories as category (category.id)}
          <div class="col">
            <div class="d-flex mb-3 align-items-end">
              <h3 class="subtle-header mb-0 flex-grow-1">{category.name}</h3>
              {#if filteredCategoryId !== null}
                <a class="small" href="/classes/{params.id}/log">Show all</a>
              {/if}
            </div>
            <div class="d-grid gap-3 mb-4">
              {#each leaderboard.skills.filter(x => x.skillCategoryId === category.id) as skill (skill.skillId)}
                <SkillCheckBox
                  skillId={skill.skillId}
                  skillName={skill.skillName}
                  proficiencyLevel={skill.lastRecordedProficiency}
                  checked={checkedSkills.has(skill.skillId)}
                  onchange={val => {
                    if (val) {
                      checkedSkills.add(skill.skillId);
                    } else {
                      checkedSkills.delete(skill.skillId);
                    }
                  }}
                />
              {/each}
            </div>
          </div>
        {/each}
      </div>
    {/await}

    <BottomNextBtn disabled={checkedSkills.size === 0} />
  </fieldset>
</form>
